import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {SkjermetEntitetType} from "felles-ng2/tjenester/datalager/SkjermingDatatjeneste";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('SkjermingBeskrivelseKomponent');

//Se skjerming-vis.stories.ts for relevant storybook

/**
 * Viser tekst som forklarer hva bruker ikke har tilgang til gitt SkjermetEntitetType.
 */
@Component({
    selector: 'skjerming-beskrivelse',
    templateUrl: 'skjerming-beskrivelse.html',
    imports: [
        TipsKomponent,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkjermingBeskrivelseKomponent {
    type = input.required<SkjermetEntitetType>();
    typer = SkjermetEntitetType;
}
